<template>
	<div>
		<div class="title">附件上传
			<!-- 大地低职业展示 -->
			<span v-if="info.productCode=='CCIC_EMPLOYER_LIABILITY_L1'" class="ml20 red font14">请与业务人员沟通确认投保公司、实际用工单位、职业类别信息无误后上传盖章材料。</span>
		</div>
		<Form :label-width="90" class="mt15 w1000">
			<FormItem 
				label="投保单及人员：" :label-width="110">
				<div class="desc">
					请先下载投保单和人员清单，盖上公司公章后再回传，<a @click="download" target="_blank">下载投保单与人员清单</a><br />
					<span v-if="multiple" style="color:red">（一张投保单和一张人员清单，为同一文件不同sheet页，两张都需要分别签字盖章上传）</span>
				</div>
				<Form class="policy" :model="form" ref="form" :label-width="0">
					<Form-item 
						class="policy-item" 
						v-for="(p,i) in form.fileList"
						:prop="'fileList.' + i + '.fileUrl'"
						:key="i"
						:rules="{required:true,message:'请上传',trigger:'change'}">
						<UploadImg 
							v-model="p.fileUrl" 
							@on-remove="removeImg(i)"
							@on-success="val=>{uploaded(val, i)}"
							:show-del="form.fileList.length>1" />
						<Input v-model="p.fileUrl" v-show="false"></Input>
					</Form-item>
					<div class="policy-item" v-if="multiple&&form.fileList.length<10">
						<a @click="add">添加投保单</a>
					</div>
				</Form>
			</FormItem>
		</Form>
	</div>
</template>
<script>
import UploadImg from './UploadImg'
export default {
	components:{ UploadImg },
	props:{ 
		info:Object,
		multiple:Boolean
	},
	data () {
		return{
			form:{
				fileList:this.info.fileList.length>0?this.info.fileList:[{
					fileUrl:''
				}]
			}
		}
	},
	methods:{
		uploaded(file, index){
			let obj = {
				fileUrl:file.url,
				fileName:file.name,
				fileType:'APPLICATION'
			}
			this.$set(this.form.fileList, index, obj)
		},
		async val () {
			let flag = await this.$refs.form.validate();
			if(!flag)return;
			return new Promise((resolve,reject)=>{
				resolve(this.form)
			})
		},
		add () {
			this.form.fileList.push({
				fileUrl:''
			})
		},
		removeImg (i) {
			this.form.fileList.splice(i,1);
		},
		// 下载模板
		download() {
			this.$axios.post('/broker/export/exportApplication.json',{
				bizId: this.info.bizId,
				productCode: this.info.productCode,
				applicationId: this.$route.params.id
			}).then(res=>{
				if(res){
					this.getBlob(res).then((blob) => {
						this.saveAs(blob, '人员列表')
					})
				}
			})
		},
		getBlob(url) {
			return new Promise((resolve) => {
				const xhr = new XMLHttpRequest()
				xhr.open('GET', url, true)
				xhr.responseType = 'blob'
				xhr.onload = () => {
				if (xhr.status === 200) {
					resolve(xhr.response)
				}
				}
				xhr.send()
			})
		},
		// 自定义下载文件名称
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			} else {
				const link = document.createElement('a')
				const body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob) // 创建对象url
				link.download = filename

				// fix Firefox
				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)

				window.URL.revokeObjectURL(link.href) // 通过调用 URL.createObjectURL() 创建的 URL 对象
			}
		}
	},
	// watch:{
	// 	'info.fileList' (v) {
	// 		this.form.fileList = v;
	// 	}
	// }
}
</script>
<style scoped>
	.policy{
		display:flex;
	}
	.policy-item{
		margin-right: 15px;
	}
	.font14{
		font-size: 14px;
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerDadi/common/sunshineUpload.vue